export default "__VITE_ASSET__369ea98f__"